function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M17.1,2.1c0.9,0,1.7,0.5,1.9,1.3l5.2,19.1c0.2,0.5,0.1,1-0.1,1.5c-0.2,0.5-0.6,0.8-1.1,0.9c-0.2,0.1-0.4,0.1-0.6,0.1 c-0.9,0-1.6-0.6-1.9-1.5L15.3,4.4c-0.1-0.4,0-1.1,0.2-1.4C15.6,3,16.1,2.1,17.1,2.1z"
}), React.createElement("path", {
  d: "M11.1-0.1c-1.1,0-2,0.9-2,2V23c0,1.1,0.9,2,2,2s2-0.9,2-2V1.9C13,0.8,12.2-0.1,11.1-0.1z"
}), React.createElement("path", {
  d: "M2.9-0.1c-1.1,0-2,0.9-2,2V23c0,1.1,0.9,2,2,2s2-0.9,2-2V1.9C4.8,0.8,4-0.1,2.9-0.1z"
}));

var SvgLibraryIcon = function SvgLibraryIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLibraryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/library-icon.8f7b2abf.svg";
export { ForwardRef as ReactComponent };